import { LargeScreen, SmallScreen } from "Core/Responsive";

import { AppHeader } from "./AppHeader";
import { AppMenuIconButton } from "./AppMenuIconButton";
import { ClassicVersionButton } from "./ClassicVersionButton";
import React from "react";
import { ShowMore } from "./ShowMore";
import { UniversalSearch } from "./UniversalSearch/UniversalSearch";
import { UserDropDown } from "./UserDropDown";
import { observer } from "mobx-react";
import { useHeaderIconItems } from "./AppMenuIconItems";
import { useStyles } from "./AppMenu.styles";
import { OpsGenieButton } from "Apps/OpsGenie/Components/Shared/OpsGenieButton";

const AppMenuBase = () => {
    const classNames = useStyles();
    const headerIconItems = useHeaderIconItems();

    return (
        <div className={classNames.root} role="banner">
            <AppHeader />
            <UniversalSearch />
            <SmallScreen>
                <div className={classNames.rightItemContainer}>
                    <OpsGenieButton />
                    <ShowMore />
                    <UserDropDown />
                </div>
            </SmallScreen>
            <LargeScreen>
                <div className={classNames.rightItemContainer}>
                    {/* // To do: show notification number and show flyout */}
                    {headerIconItems
                        .filter((item) => item.isHiddenOnLargeScreen !== true)
                        .map((filteredItem) => (
                            <AppMenuIconButton key={filteredItem.key} item={filteredItem} />
                        ))}
                    <div data-tourstep="classicVersion">
                        <ClassicVersionButton />
                    </div>
                    <UserDropDown />
                </div>
            </LargeScreen>
        </div>
    );
};

export const AppMenu = observer(AppMenuBase);
